import React from 'react';
import Loader from 'react-loader-spinner';
import './global-loader.css';

export default class GlobalLoader extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      message: props.message || '',
      style: props.style
    };
  }

  render() {
    return (
      <div className='global-loader-container' style={this.state.style}>
        <Loader type='Grid' color='#f38894' height='30' width='30' />
        <div className='global-loader-message'>{this.state.message}</div>
      </div>
    );
  }
}
